import type { SlateBlock, TableBlock } from '@atlas/renderer';

export default function isTableBlock(block: SlateBlock): block is TableBlock {
    return block.type === 'table';
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isTableBlock', async () => {
        it.todo('look for native implementation from slate');
    });
}

// #endregion
